import { SearchIcon } from "@heroicons/react/outline";
import { Dispatch, SetStateAction } from "react";
import InputField from "./InputField";

function SearchField<T>({ query, setQuery, placeholder, id, type }: { query: string, setQuery: Dispatch<SetStateAction<T>>, placeholder: string, id?: string, type: "text" | "number" | "email" | "password", }) {
  return (
    <InputField<T>
      id={id}
      placeholder={placeholder}
      type={type}
      prependIcon={<SearchIcon className="h-4 w-4" />}
      value={query}
      onChange={(query) => setQuery(query)}
    />
  )
}

export default SearchField;